module.exports = __webpack_public_path__ + "img/teaching2.57eda80b.png";